import { ActionModel, ActionResponse } from '../ActionModel';

const USER_ACTIONS = [
    {
        action: 'bulk_add_role',
        label: 'add_role',
        endpoint: 'actions',
        allow_filters: true,
        default_filters: {},
        required_fields: ['config'],
        is_bulk_action: true,
        delete_item: false,
        disabled: { condition: false }
    },
    {
        action: 'bulk_remove_role',
        label: 'remove_role',
        endpoint: 'actions',
        allow_filters: true,
        default_filters: {},
        required_fields: ['config'],
        is_bulk_action: true,
        delete_item: false,
        disabled: { condition: false }
    }
];

export class UserV1 extends ActionModel {
    fields() {
        return {
            username: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    getEmail() {
        return this.email || '';
    }

    get resolvedName() {
        const firstName = this.object.first_name || '';
        const lastName = (this.object.last_name || '').toUpperCase();
        const app = this.object.application_name;
        return app ? app : (firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName) || '-';
    }

    get clientId() {
        const name = this.object.username;
        if (!name.includes('app_')) {
            return null;
        }
        return name.replace('app_', '');
    }

    static listUrl({ organizationId, useCase }) {
        const endpoint = useCase === 'applications' ? 'v1/applications' : 'users';

        if (!organizationId) {
            return `/ticket/${endpoint}`;
        }
        return `/ticket/organizations/${organizationId}/${endpoint}`;
    }

    static getModelActions() {
        return USER_ACTIONS;
    }

    static buildPayload(params, action) {
        return {
            type: action.action,
            resource_query_filter: this.parseFilters(params.filters, action),
            config: params.config || {}
        };
    }

    static pollBulkAction(response) {
        const result = new ActionResponse(response);
        return result.poll(5000, '/ticket/async-tasks/actions');
    }

    static getItemUrl({ id, useCase, ...props }) {
        if (useCase === 'applications' && id.startsWith('user_')) {
            id = id.slice(5, id.length);
        }
        return super.getItemUrl({ id, useCase, ...props });
    }
}
